<template>
	<div>
		<app-header></app-header>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 mt-5">
                    <div class="alert primary">
                        <div class="alert-text">
                           <div class="font-md">
                               <span class="fw-bold">{{$t("investment.name")}}:</span> {{investment.name}}
                           </div>
                            <div class="font-md">
                            <span class="fw-bold">{{$t("investment.email")}}: </span>{{investment.email}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container mt-4 row">
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.wallet")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.walletAddress}}
                     </div>
                     <div class="col-sm-3 fw-bold font-sm">
                         {{$t("investment.transaction")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.transaction}}
                    </div>
                       <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.sendingAddress")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.sendingAddress}}
                    </div>
                       <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.purchasingAmount")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        <span class="primary--text">{{investment.purchasingAmount}}</span>
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.paymentType")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        <span class="primary--text">{{investment.paymentType}}</span>
                    </div>
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.sentTime")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.sentTime}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.recordTime")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.recordTime}}
                    </div>
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.averagePrice")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.averagePrice}}
                    </div>
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.purchasingAmountInUSD")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.purchasingAmountInUSD}}
                    </div>
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.bonusRate")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.bonusRate}}
                    </div>
                      <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.bonus")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        {{investment.bonus}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("investment.totalIOB")}}
                     </div>
                     <div class="col-sm-9 mb-3">
                        <span class="primary--text">{{investment.totalIOB}}</span>
                    </div>
<!--                     <div class="col-sm-6 col-lg-4 fw-bold h5">
                        <span>{{$t("investment.wallet")}}</span><br><br>
                        <span>{{$t("investment.transaction")}}</span><br><br>
                        <span>{{$t("investment.sendingAddress")}}</span><br><br>
                        <span>{{$t("investment.purchasingAmount")}}</span><br><br>
                        <span>{{$t("investment.paymentType")}}</span><br><br>
                        <span>{{$t("investment.sentTime")}}</span><br><br>
                        <span>{{$t("investment.recordTime")}}</span><br><br>
                        <span>{{$t("investment.averagePrice")}}</span><br><br>
                        <span>{{$t("investment.purchasingAmountInUSD")}}</span><br><br>

                        <span>{{$t("investment.bonusRate")}}</span><br><br>
                        <span>{{$t("investment.bonus")}}</span><br><br>
                        <span>{{$t("investment.totalIOB")}}</span><br><br>
                    </div>
                    <div class="col-sm-6 col-lg-7 h5">
                        <span>{{investment.walletAddress}}</span><br><br>
                        <span>{{investment.transaction}}</span><br><br>
                        <span>{{investment.sendingAddress}}</span><br><br>
                        <span class="primary--text">{{investment.purchasingAmount}}</span><br><br>
                        <span class="primary--text">{{investment.paymentType}}</span><br><br>
                        <span>{{investment.sentTime}}</span><br><br>
                        <span>{{investment.recordTime}}</span><br><br>
                        <span>{{investment.averagePrice}}</span><br><br>
                        <span>{{investment.purchasingAmountInUSD}}</span><br><br>

                        <span>{{investment.bonusRate}}</span><br><br>
                        <span>{{investment.bonus}}</span><br><br>
                        <span class="primary--text">{{investment.totalIOB}}</span><br><br>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
    export default {
        data(){
            return{
                investmentId: this.$route.params.investmentId,  //投资记录id
                investment: {},                                 //投资对象
            }
        },
        computed: {

        },
        created(){
            this.getInvestmentById();
        },
        mounted(){
            
        },
        watch:{
            //监听路由的investmentId变化之后就重新加载页面
            $route(){
                this.investmentId = this.$route.params.investmentId;
            },
            investmentId(){
                this.getInvestmentById();
            }
        },        
        methods: {
            getInvestmentById(){
                this.investment = JSON.parse(sessionStorage.getItem('investment'));
            },
        },
    }
</script>


// WEBPACK FOOTER //
// InvestmentData.vue?2c5c8065